export const REQUESTED_FEATURE_LIST = `REQUESTED_FEATURE_LIST`
export const REQUESTED_FEATURE_LIST_SUCCEEDED = `REQUESTED_FEATURE_LIST_SUCCEEDED`
export const REQUESTED_FEATURE_LIST_FAILED = `REQUESTED_FEATURE_LIST_FAILED`
